import { useAgendaSettingsContext } from './Context';
import { dayLabels, minutesToTime, timeToMinutes } from '../../Enum';
import { Trash2 } from 'lucide-react';

export default function AgendaSettingsHorarios() {
    const { horarios, setHorarios, submitHorarios, loading, canEditAgendaSettings } = useAgendaSettingsContext();

    const handleAddSlot = (day: string) => {
        const newHorarios = { ...horarios };
        newHorarios[day].push({ start: 0, end: 0 });
        setHorarios(newHorarios);
    };

    const handleSlotChange = (day: string, slotIndex: number, field: 'start' | 'end', value: string) => {
        const newHorarios = { ...horarios };
        newHorarios[day][slotIndex][field] = timeToMinutes(value);
        setHorarios(newHorarios);
    };

    const handleRemoveSlot = (day: string, slotIndex: number) => {
        const newHorarios = { ...horarios };
        newHorarios[day].splice(slotIndex, 1);
        setHorarios(newHorarios);
    };

    return (
        <div className="w-full space-y-4">
            {Object.entries(horarios)?.map(([day, horario]) => (
                <div key={day} className="rounded-xl border border-base-200 bg-base-100 p-4 space-y-3">
                    <div className="flex items-center justify-between gap-3">
                        <h3 className="text-sm font-semibold text-base-content/70 uppercase">{dayLabels?.[day]}</h3>
                        <button
                            type="button"
                            disabled={loading || !canEditAgendaSettings}
                            onClick={() => handleAddSlot(day)}
                            className="btn btn-outline btn-sm"
                        >
                            Adicionar intervalo
                        </button>
                    </div>
                    {horario?.length === 0 && (
                        <div className="text-xs text-base-content/60">Nenhum intervalo configurado.</div>
                    )}
                    {horario?.map((slot, slotIndex) => (
                        <div key={slotIndex} className="flex flex-wrap items-center gap-3">
                            <input
                                type="time"
                                value={minutesToTime(slot.start)}
                                onChange={(e) => handleSlotChange(day, slotIndex, 'start', e.target.value)}
                                className="input input-bordered input-sm w-28"
                                disabled={loading || !canEditAgendaSettings}
                            />
                            <input
                                type="time"
                                value={minutesToTime(slot.end)}
                                onChange={(e) => handleSlotChange(day, slotIndex, 'end', e.target.value)}
                                className="input input-bordered input-sm w-28"
                                disabled={loading || !canEditAgendaSettings}
                            />
                            <button
                                type="button"
                                disabled={loading || !canEditAgendaSettings}
                                onClick={() => handleRemoveSlot(day, slotIndex)}
                                className="btn btn-error btn-sm"
                            >
                                <Trash2 aria-hidden="true" />
                            </button>
                        </div>
                    ))}
                </div>
            ))}

            <div className="mt-6 flex justify-end">
                <button
                    onClick={submitHorarios}
                    disabled={loading || !canEditAgendaSettings}
                    className="btn btn-primary shadow-md w-full sm:w-auto min-w-[160px]"
                    type="submit"
                >
                    Salvar alterações
                </button>
            </div>
        </div>
    );
}
